import addGuestButton from "./add-guest-button";
import guestList from "./guest-list";

export default function(event) {
    const element = event.target;
    element.setAttribute('disabled', true);
    const id = element.dataset.id;
    const guest = guestList.removeGuestById(id);
    // Remove add button, regardless of the guest being valid or not
    const parent = element.parentNode;
    element.remove();

    if (guest === false) {
        // Guest isn't valid, so don't add remove button
        parent.remove();
        return;
    }

    const addButton = document.createElement('button');
    addButton.classList.add('btn', 'btn-primary', 'cnaq-reserve-form__guest-remove-btn');
    addButton.innerHTML = 'Add';
    addButton.dataset.id = id;
    addButton.addEventListener('click', addGuestButton);

    parent.append(addButton);
}